/**
 * Trim a file selection so at most `max` PDF files remain (0 = unlimited).
 * Non-PDF files (images, etc.) pass through untouched. Because the result is
 * derived from the current selection, removing a PDF from the selection frees
 * its slot automatically.
 */
export function enforcePdfFileLimit(
  files: File[],
  max: number
): { accepted: File[]; removedCount: number } {
  if (max <= 0) return { accepted: files, removedCount: 0 };
  let pdfCount = 0;
  const accepted = files.filter((f) => {
    if (f.type !== 'application/pdf') return true;
    pdfCount += 1;
    return pdfCount <= max;
  });
  return { accepted, removedCount: files.length - accepted.length };
}
